(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-about-us"]) return;
  try {
    
var owl = $('#owl-abouttesti');
owl.owlCarousel({
  margin: 0,
  loop: true,
  nav: false,
  autoplay: true,
  dots: false,
  responsive: {
    0: { items: 1 },
    992: { items: 2 }
  }
});

  } catch(e) { console.error(e); }
})();
})();
